import jwtDecode from 'jwt-decode';

export const parseJwt = (token: string) => {
  return jwtDecode<any>(token);
};
